<div>
    <form data-automation-attribute="form-confirm-dialog">
        <div class="modal-header modalHeaderBlack">
            <h6 class="modal-title">
                {{ "AppointmentListPage.confirm" | translate }}
            </h6>
            <span aria-label="Close" class="close">
                <mat-icon matTooltip="{{ 'common.close' | translate }}"  (click)="buttonClick('no')">clear</mat-icon>
            </span>
        </div>
        <div style="margin-left: 10px;">
            <p style="font-weight: bold;font-size: initial;">
                Do you want to proceed with print?
            </p>
        </div>
        <div style="margin: 10px;">
            <div style="display: flex;align-items: anchor-center;">
                <span>Patient Label with Salutation</span> &nbsp;&nbsp;
                <mat-button-toggle-group name="fontStyle" aria-label="Font Style" class="custom-toggle-group" 
                [(ngModel)]="salutationValue">
                    <mat-button-toggle value="yes">Yes</mat-button-toggle>
                    <mat-button-toggle value="no">NO</mat-button-toggle>
                </mat-button-toggle-group>
            </div>
        </div>

        <div class="modal-footer modalFooterConfirmDialog">
            <div>
                <button mat-mini-fab class="btnCyan" type="button" data-automation-attribute="button-save-dialog"
                    matTooltip="{{ 'payerInfo.yes' | translate }}" (click)="buttonClick('yes')">
                    <mat-icon>done</mat-icon>
                </button>
            </div>
        </div>
    </form>
</div>